import './features/shared/i18n/index.ts';

import { StrictMode, Suspense, useEffect, useState } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { GigyaProvider } from '@ciam/gigya-api';
import { ThemeProvider } from '@ciam/theme';
import { LoadingSpinner, ModalProvider } from '@ciam/ui';

import type { PropsWithChildren } from 'react';
import { i18nInstance } from '@ciam/i18n/index.tsx';

// i18n 초기화 대기 컴포넌트
function I18nInitializer({ children }: PropsWithChildren) {
  const [initialized, setInitialized] = useState(i18nInstance.isInitialized);

  useEffect(() => {
    if (!initialized) {
      const handleInitialized = () => setInitialized(true);
      i18nInstance.on('initialized', handleInitialized);
      return () => i18nInstance.off('initialized', handleInitialized);
    }
  }, [initialized]);

  if (!initialized) return <LoadingSpinner />;
  return <>{children}</>;
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <ModalProvider>
        <I18nInitializer>
          <Suspense fallback={<LoadingSpinner />}>
            <GigyaProvider>
              <App />
            </GigyaProvider>
          </Suspense>
        </I18nInitializer>
      </ModalProvider>
      <LoadingSpinner />
    </ThemeProvider>
  </StrictMode>,
);
